import AssignmentDropdown from 'components/ui/AssignmentDropdown';
import React from 'react';
import { Checkbox, Dropdown, Input } from 'semantic-ui-react';
import EmailFields from './EmailFields';
import { ContactOption, FileUpload } from './types';
import RequestNotes from './RequestNotes';

interface PropTypes {
  bulkDueBy: string;
  setBulkDueBy: (bulkDueBy: string) => void;
  assignees: any[];
  setBulkAssignTo: (assignee: any) => void;
  isAbstractSearchSelected: boolean;
  setBulkAbstractAssignTo: (abstractAssignee: any) => void;
  abstractDefaultAssignee: any;
  bulkAdditionalSendEmails: number[];
  setBulkAdditionalSendEmails: (bulkAdditionalSendEmails: number[]) => void;
  bulkIsPriority: boolean;
  setBulkIsPriority: (isPriority: boolean) => void;
  bulkIsSixMonthContin: boolean;
  setBulkIsSixMonthContin: (isSixMonthContin: boolean) => void;
  bulkAssignTo: any;
  bulkAbstractAssignTo: any;
  bulkRequestNotes: string;
  setBulkRequestNotes: (bulkRequestNotes: string) => void;
  bulkScheduleSendDateTime: string;
  setBulkScheduleSendDateTime: (dateTime: string) => void;
  handleBulkScheduleSendCheck: (checked: boolean) => void;
  bulkSubject: string;
  bulkEmailBody: string;
  bulkScheduleSend: boolean;
  scheduleSendMin: string;
  setBulkSubject: (subject: string) => void;
  bulkSelectedContacts: ContactOption[];
  bulkContactsList: ContactOption[];
  setBulkSelectedContacts: (selections: ContactOption[]) => void;
  bulkSelectedCcEmails: ContactOption[];
  setBulkSelectedCcEmails: (selections: ContactOption[]) => void;
  bulkSelectedBccEmails: ContactOption[];
  setBulkSelectedBccEmails: (selections: ContactOption[]) => void;
  bulkSendEmail: boolean;
  setBulkSendEmail: (bulkSendEmail: boolean) => void;
  bulkVendorEmailAttachments: FileUpload[];
  setBulkVendorEmailAttachments: (attachments: FileUpload[]) => void;
}

export const BulkSearchesInfo = (props: PropTypes) => {
  const hasVendorAssignee = props.bulkAbstractAssignTo?.vendorId > 0 || props.bulkAssignTo?.vendorId > 0;

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ display: 'flex', gap: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: 16 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <label style={{ fontSize: 14, color: '#444444' }}>Due By</label>
            <Input
              style={{ width: 300, height: 48 }}
              value={props.bulkDueBy}
              type="date"
              onChange={e => props.setBulkDueBy(e.target.value)}
              fluid
            />
          </div>
        </div>
      </div>
      <div style={{ marginTop: 24, marginBottom: 24, display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <AssignmentDropdown
            assignees={props.assignees}
            buttonText="Select employee/vendor"
            onClick={(e: any) => {
              props.setBulkAssignTo(e);
            }}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
          <AssignmentDropdown
            assignees={props.assignees}
            buttonText="Select Abstract employee/vendor"
            disabled={!props.isAbstractSearchSelected}
            onClick={(e: any) => {
              props.setBulkAbstractAssignTo(e);
            }}
            prevSelected={props.bulkAbstractAssignTo ?? props.abstractDefaultAssignee}
          />
        </div>
        <div style={{ width: 300, marginLeft: 16 }}>
          <Dropdown
            multiple
            selection
            search
            placeholder="Additional users"
            options={
              (props.assignees || [])[0]?.items.map((i: any) => ({ value: i.id, text: i.name, key: i.id })) ||
              []
            }
            onChange={(e, { value }) => props.setBulkAdditionalSendEmails(value as number[])}
            closeOnChange
            fluid
            style={{ minHeight: 48 }}
            value={props.bulkAdditionalSendEmails}
          />
        </div>
        <div style={{ marginLeft: 16 }}>
          <Checkbox
            label="Is Priority"
            checked={props.bulkIsPriority}
            onChange={(e, { checked }) => props.setBulkIsPriority(checked)}
          />
        </div>
        <div style={{ marginLeft: 16 }}>
          <Checkbox
            label="Charge Full"
            checked={props.bulkIsSixMonthContin}
            onChange={(e, { checked }) => props.setBulkIsSixMonthContin(checked)}
          />
        </div>
      </div>
      {(props.bulkAssignTo || props.bulkAbstractAssignTo) && !hasVendorAssignee && (
        <RequestNotes
          width={616}
          marginLeft={0}
          marginTop={0}
          value={props.bulkRequestNotes}
          onChange={value => props.setBulkRequestNotes(value)}
        />
      )}
      {hasVendorAssignee && (
        <div style={{ marginTop: 16 }}>
          <EmailFields
            selectedCcEmails={props.bulkSelectedCcEmails}
            selectedBccEmails={props.bulkSelectedBccEmails}
            setSelectedContacts={props.setBulkSelectedContacts}
            selectedContacts={props.bulkSelectedContacts}
            contactsList={props.bulkContactsList}
            disabled={!props.bulkSendEmail}
            setSelectedCcEmails={props.setBulkSelectedCcEmails}
            setSelectedBccEmails={props.setBulkSelectedBccEmails}
            subject={props.bulkSubject}
            emailBodyPreview={props.bulkSendEmail ? props.bulkEmailBody : ''}
            scheduleSend={props.bulkScheduleSend}
            scheduleSendDateTime={props.bulkScheduleSendDateTime}
            scheduleSendMin={props.scheduleSendMin}
            setSubject={props.setBulkSubject}
            handleScheduleSendCheck={props.handleBulkScheduleSendCheck}
            setScheduleSendDateTime={props.setBulkScheduleSendDateTime}
            sendEmailChecked={props.bulkSendEmail}
            handleSendEmailCheck={checked => props.setBulkSendEmail(checked)}
            attachments={props.bulkVendorEmailAttachments}
            setAttachments={props.setBulkVendorEmailAttachments}
            requestNotes={
              <RequestNotes
                width={'100%'}
                marginLeft={0}
                marginTop={16}
                value={props.bulkRequestNotes}
                onChange={value => props.setBulkRequestNotes(value)}
              />
            }
          />
        </div>
      )}
    </div>
  );
};
